import { useAuth } from '../context/AuthContext'
import { t, tEn } from '../i18n/translations'
import TeacherCodeForm from './TeacherCodeForm'

// The dialog a teacher lands in from kidase.geezword.com/?redeem=1
//
// Separate from UpgradePrompt on purpose. That one returns null for anyone
// with Premium, which would shut the door on exactly the people most likely to
// follow this link: a teacher who already subscribes, or one re-reading their
// own status. This dialog opens regardless.
//
// It owns no redemption logic. TeacherCodeForm does the work, unchanged, and
// the server remains the only thing that decides anything.
export default function RedeemDialog({ onClose }) {
  const { hasLifetimeTeacherAccess } = useAuth()

  return (
    <div className="upgrade-overlay" onClick={onClose}>
      <div className="upgrade-prompt" role="dialog" aria-modal="true" aria-labelledby="redeem-title" onClick={e => e.stopPropagation()}>
        <button className="upgrade-close" onClick={onClose} aria-label={t('teacherCodeCancel')}>&#10005;</button>
        <h3 className="upgrade-title" id="redeem-title" title={tEn('teacherCodeLink')}>{t('teacherCodeLink')}</h3>

        {hasLifetimeTeacherAccess ? (
          // Already a teacher: say so rather than inviting a second redemption
          // the server would refuse.
          <>
            <p className="teacher-code-granted" title={tEn('teacherLifetimeTitle')}>{t('teacherLifetimeTitle')}</p>
            <p className="teacher-code-note" title={tEn('teacherLifetimeDesc')}>{t('teacherLifetimeDesc')}</p>
            <button className="upgrade-cta" onClick={onClose}>{t('browseContinue')}</button>
          </>
        ) : (
          <TeacherCodeForm onDone={onClose} />
        )}
      </div>
    </div>
  )
}
